var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnsaveIcon12X16 = function SvgUnsaveIcon12X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "social-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.998,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1.625.781L6 12.28l4.374 3.5A1 1 0 0 0 12 15V1a1 1 0 0 0-1-1Z",
    fillRule: "evenodd"
  })));
};
export default SvgUnsaveIcon12X16;